import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=c9044d52&"
import script from "./productList.vue?vue&type=script&lang=ts&"
export * from "./productList.vue?vue&type=script&lang=ts&"
import style0 from "./productList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports